import React, { useState } from "react";
import { deleteTimetableDay } from "../../services/adminTimeTableServices";
import SessionTable from "./SessionTable";
import CopyDayModal from "./CopyDayModal";

const TimetableDayAccordion = ({ day, reload, onSessionUpdated, selected, onToggleSelect }) => {
  const [open, setOpen]         = useState(false);
  const [copyOpen, setCopyOpen] = useState(false);

  const handleDeleteDay = async (e) => {
    e.stopPropagation();
    if (!window.confirm("Delete this day and all its sessions?")) return;
    try { await deleteTimetableDay(day.id); reload(); }
    catch (err) { alert(err.response?.data?.message || "Failed to delete day"); }
  };

  const activeCount   = day.sessions?.filter((s) => s.status === "ACTIVE").length   || 0;
  const draftCount    = day.sessions?.filter((s) => s.status === "DRAFT").length    || 0;
  const totalSessions = day.sessions?.length || 0;

  return (
    <>
      <div className="tt-day-card">
        <div className="tt-day-header" onClick={() => setOpen(!open)}>
          <div className="tt-day-header-left">
            {/* Checkbox — stop propagation so clicking it doesn't toggle accordion */}
            <input
              type="checkbox"
              className="tt-day-checkbox"
              checked={selected}
              onChange={onToggleSelect}
              onClick={(e) => e.stopPropagation()}
            />
            <span className={`tt-day-chevron ${open ? "open" : ""}`}>▶</span>
            <span className="tt-day-date">{day.localDate}</span>
            <div className="tt-day-meta">
              <span className="tt-session-count">{totalSessions} session{totalSessions !== 1 ? "s" : ""}</span>
              {activeCount > 0 && <span className="tt-badge tt-badge-active">{activeCount} active</span>}
              {draftCount  > 0 && <span className="tt-badge tt-badge-draft">{draftCount} draft</span>}
            </div>
          </div>

          <div className="tt-day-actions" onClick={(e) => e.stopPropagation()}>
            <button className="tt-text-btn primary" onClick={() => setCopyOpen(true)}>
              📋 Copy
            </button>
            <button className="tt-text-btn danger" onClick={handleDeleteDay}>
              🗑 Delete
            </button>
          </div>
        </div>

        {open && (
          <div className="tt-day-body">
            <SessionTable
              dayId={day.id}
              dayDate={day.localDate}
              sessions={day.sessions}
              reload={reload}
              onSessionUpdated={onSessionUpdated}
            />
          </div>
        )}
      </div>

      {copyOpen && <CopyDayModal day={day} onClose={() => setCopyOpen(false)} reload={reload} />}
    </>
  );
};

export default TimetableDayAccordion;
